import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from "./Images/A.pTechNewLogo_4.png";

function Footer() {

    const startYear = 2025; // jo year se site start hui
    const currentYear = new Date().getFullYear();



    return (
        <footer className="footer">
            <div className="footer-container">
                {/* About Section */}
                <div className="footer-section about">
                    <img src= {logo} alt="Logo" className="footer-logo" />
                    <p>
                        A.P Tech Solution (APTS) is a trusted software solutions provider, delivering innovative digital products, scalable applications, and reliable technology services. We help businesses streamline processes, enhance customer experiences, and drive sustainable global growth.</p>
                </div>

                {/* Links Section */}
                <div className="footer-section links">
                    <div className='CompanyCenter'>
                        <h3>Quick Links</h3>
                        <ul>
                           

                            <li><Link to="/AboutUs">About Us</Link></li>
                            <li><Link to="/search">Our Services</Link></li>
                            <li><Link to="/TermsAndcondition">Terms & Conditions</Link></li>
                            <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>

                            {/* <li><a href="Gallery">Gallery</a></li> */}

                            <li>
                                <Link to={{ pathname: "/contact" }} state={{ scrollTo: "form" }}>
                                    Contact Us
                                </Link>
                            </li>

                        </ul>
                    </div>
                </div>

                {/* Contact Section */}
                <div className="footer-section contact">
                    <div className='ContactUsCenter'>
                        <h3>Contact Us</h3>
                        <h6>
                            <i className="fas fa-envelope"></i>{' '}
                            <a href="mailto:info@aptechsolution.com" target="_blank" rel="noopener noreferrer">
                               info@aptechsolution.com
                            </a>
                        </h6>
                        <h6>
                            <i className="fas fa-phone"></i>{' '}
                            <a href="tel:+918490957541">
                                +91-8490957541
                            </a>
                        </h6>
                        <h6>
                            <i className="fab fa-whatsapp"></i>{' '}
                            <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                                +91-9316580274
                            </a>
                        </h6>
                        <h6>
                            <i className="fas fa-map-marker-alt"></i>{' '}
                            <a
                                href="https://maps.app.goo.gl/aiU5y3pEH4R3YjmCA"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                               57 Krishnavilla, Opp: ONGC Colony Behind Nayra Petrol Pump Near D'Mart, Ankleshwar 393001, Gujarat, India
                            </a>
                        </h6>

                    </div>
                </div>

                {/* Social Media Section */}
                <div className="footer-section social">
                    <div className='FollowCenter'>
                        <h3>Follow Us</h3>
                        <div className="social-icons">
                            <a href="https://www.instagram.com/aptechsolution_it/" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/aptech-solution/" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-linkedin-in"></i>
                            </a>
                            <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-whatsapp"></i>
                            </a>
                            {/* <a href="https://x.com/globalinkcorp?s=11" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-twitter"></i>
                            </a> */}
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Copyright */}
            {/* <div className="footer-bottom">
                &copy; 2025 A.P Tech Solutions. All rights reserved.
                Designed & Developed by A.P Tech Solutions.
            </div> */}
            {/* <div className="footer-bottom">
                &copy; {startYear}
                {currentYear > startYear ? ` - ${currentYear}` : ""}{" "}
                <strong>A.P Tech Solutions</strong>. All rights reserved.
                Designed &amp; Developed by <strong>A.P Tech Solutions</strong>.
            </div> */}

            <div className="footer-bottom">
                &copy; {startYear}
                {currentYear > startYear ? ` - ${currentYear}` : ""}{" "}
                <span className="footer-brand">A.P Tech Solution</span>. All rights reserved.
                Designed &amp; Developed by <span className="footer-brand">A.P Tech Solution</span>.
            </div>
        </footer>
    );
}

export default Footer;
